import React from 'react'
import { Typography, Stack, Box, Button, Grid, Dialog, DialogContent, useMediaQuery } from '@mui/material';
import CloseModalIcon from '../../icons/RoundCloseIcon.svg';
import ConfirmPaymentIcon from '../../icons/ConfirmPaymentIcon.svg';

const PaymentConfirmation = (props: any) => {
    const isOnMobileScreen = useMediaQuery("(max-width:600px)");
    const style = {
        height: isOnMobileScreen ? '' : '680px'
    };
    return (
        <React.Fragment>
            <Dialog
                open={props.open}
                onClose={props.onClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                fullScreen={isOnMobileScreen}
                fullWidth={true}
                disableEnforceFocus
                style={{
                    background: "none",
                }}
                PaperProps={{
                    style: {
                        pointerEvents: "auto"
                    },
                }}
            >
                <DialogContent>
                    <Box
                        sx={style}
                    >
                        <Grid container spacing={2} style={{ marginBottom: '20px' }}>
                            <Grid item xs={2}> </Grid>
                            <Grid item xs={8}>
                                <Typography id="payment-method-title" style={{ textAlign: 'center' }}>Confirm Cancel</Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <img src={CloseModalIcon} alt="close" style={{ cursor: 'pointer', marginLeft: isOnMobileScreen?"0px": "50px" }} onClick={() => {
                                    props.onClose()
                                }} />
                            </Grid>
                            <Grid item xs={12}>
                                <Stack
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={2}>
                                    <img src={ConfirmPaymentIcon} alt="close" style={{ cursor: 'pointer', marginTop: '50px' }} onClick={() => {
                                        props.onClose()
                                    }} />
                                </Stack>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    style={{
                                        fontFamily: 'Work Sans',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '18px',
                                        lineHeight: '21px',
                                        marginTop: '50px',
                                        color: '#000000',
                                    }}
                                >
                                    Once cancelled the payment will drop off the card or bank statement in the next 24-48 hrs.
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography
                                    style={{
                                        textAlign: 'center',
                                        fontFamily: 'Work Sans',
                                        fontStyle: 'normal',
                                        fontWeight: 400,
                                        fontSize: '18px',
                                        lineHeight: '21px',
                                        marginTop: '40px',
                                        color: '#000000',
                                    }}
                                >
                                    Are you sure you want to proceed?
                                </Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Stack
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={2}
                                    style={{
                                        marginTop: '50px'
                                    }}
                                >
                                    <Button
                                        style={{
                                            height: '42px',
                                            background: '#A2DBFA',
                                            borderRadius: '24px',
                                            color: '#fff',
                                            fontFamily: 'Work Sans',
                                            fontStyle: 'normal',
                                            fontWeight: 400,
                                            fontSize: '18px',
                                            lineHeight: '22px',
                                        }}
                                        onClick={() => {
                                            props.cancelTransaction()
                                            props.onClose()
                                        }
                                        }
                                    >Yes</Button>
                                    <Button
                                        style={{
                                            height: '42px',
                                            background: '#39A2DB',
                                            borderRadius: '24px',
                                            color: '#fff',
                                            fontFamily: 'Work Sans',
                                            fontStyle: 'normal',
                                            fontWeight: 400,
                                            fontSize: '18px',
                                            lineHeight: '22px',
                                        }}
                                        onClick={props.onClose}
                                    >No</Button>
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}

export default PaymentConfirmation;
